<template>
  <Layout>
    <div class="jumbotron">
      <div class="container">
        <h1 class="display-3">Thank You!</h1>
        <p>Thank you for registering your sensor! We will process the registration and put your sensor on the air map as soon as possible.</p>
        <hr>
        <p>
          Having question?
          <a v-bind:href=" `mailto:${email}` ">Contact us</a>
        </p>
        <p class="lead">
          <router-link to="/">
            <button type="button" class="btn btn-primary btn-sm">Continue to homepage</button>
          </router-link>
        </p>
      </div>
    </div>
  </Layout>
</template>


<script>
import Layout from '@layouts/main'

export default {
  page: {
    title: 'Thank you',
    meta: [
      {
        name: 'description',
        content: 'Your sensor have been successfully registered!',
      },
    ],
  },
  data() {
    return {
      email: process.env.VUE_APP_SUPPORT_EMAIL,
    }
  },
  components: {
    Layout,
  },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>
